<template>
<div class="admun-animation">
  <div class="admunBox">
    <p class="admun" >
      {{ displayText.join("") }}
    </p> </div>
  <br>
  <div class="studioBox">
    <p class="studio">
      {{ displayText2.join("") }}
    </p>
  </div>
</div>





</template>

<script>
export default {

  data() {
    return {
      displayText: [],
      currentWord: "",
      wordIdx: 0,
      speed: 300,
      deleteSpeed: 200,
      words: ['ADMUN '],


      displayText2: [],
      currentWord2: "",
      wordIdx2: 0,
      words2: ['STUDIO'],




    };
  },
  computed: {
    // can adjust speeds based on other factors if needed
    TYPE_SPEED() {
      return this.speed
    },
    DELETE_SPEED() {
      return this.deleteSpeed
    },
    timeoutSpeed() {
      return this.TYPE_SPEED * 0.8
    },
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      if (this.words && this.words.length > 0) {
        this.currentWord = this.words[this.wordIdx].split("");
        this.wordIdx++;
        this.currentWord2 = this.words2[this.wordIdx2].split("");
        this.wordIdx2++;
        this.animate = setTimeout(this.type, this.timeoutSpeed);
      }
    },
    type() {

      // if typing...
      if (this.currentWord.length > 0) {
        this.displayText.push(this.currentWord.shift());

      }else  if (this.currentWord2.length > 0){
        this.displayText2.push(this.currentWord2.shift());
        // if done typing, then delete
      }
      else if (this.currentWord2.length === 0 && this.displayText2.length > 0 && this.currentWord.length === 0 && this.displayText.length > 0) {
         setTimeout(()=>{
          this.timeoutSpeed =  this.DELETE_SPEED ;
           this.displayText2.pop();
           setTimeout(()=>{
           this.displayText.pop();
           } , 1600);
        } , 1000);

        // if done typing & deleting
      }
        else if (
          this.currentWord.length === 0 &&
          this.displayText.length === 0
      ) {
        // change words
        if (this.wordIdx < this.words.length) {
          this.currentWord = this.words[this.wordIdx].split("");
          this.wordIdx++;
          this.timeoutSpeed = this.TYPE_SPEED;
          this.displayText.push(this.currentWord.shift());
        }
      }
      setTimeout(this.type, this.timeoutSpeed);
    }
  }
}



</script>
<style>


body, html {
  font-family: 'admun';
}

p, h1, h2, h3, h4, h5, h6 {
  font-family: 'admun';
  margin: 0;

}




.admun-animation {


justify-content: center;
  display: flex;
  height: 95px;
  color: white;
  display: flex;
  margin: 0 auto;
  align-items: center;
  width: 232px;
}


p {
  z-index: -1;
  font-size: 35px;
  font-weight: 400;
  width: 100%;

  flex-wrap: wrap;
}
.studio{
  font-size: 15px;
  letter-spacing: 14px;
}
.studioBox{
  position: absolute;
  left: 18%;
  text-align: -webkit-left;
}
.admun{
  font-size: 30px;

}
.admunBox{
  position: absolute;
  left:67%;
  height: 50%;
  text-align: -webkit-left;
}
</style>
